import styled from 'styled-components';
import useResizeObserver from 'use-resize-observer';

const Wrapper = styled.div`
    overflow-y: hidden;
    transition: height 0.3s ease;
    height: ${({ height }) => (height ? `${height}px` : `unset`)};
`;

function Expander({ children, ...props }) {
    const { ref, height } = useResizeObserver();

    return (
        <Wrapper height={height}>
            <div ref={ref} {...props}>
                {children}
            </div>
        </Wrapper>
    );
}

export default Expander;
